import * as Haptics from 'expo-haptics';
import {Platform} from 'react-native';

export function triggerHapticFeedback() {
  if (Platform.OS !== 'web') {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success);
  }
}
